import React from 'react';
import { observer } from 'mobx-react';
import { WeaRightMenu } from 'ecCom';
import { Row, Col, Button, Menu, Dropdown } from 'antd';
import $ from 'jquery';

export interface RightMenuWrapProps {
    prefixCls?: string;
    rightMenuClick?: (key: any) => void;
    rightMenus?: any[];
    isDialog?: boolean;
    quickSize?: number;
    hideRightmenu?:boolean;
    needFixedToTop?:boolean;
}
@observer
export default class RightMenuWrap extends React.Component<RightMenuWrapProps, any>{
    static defaultProps = {
        prefixCls: "coms-mode-menu-wrap",
    }
    handleButtonClick = (key) => {
        const { rightMenuClick } = this.props;
        rightMenuClick && rightMenuClick(key);
    }
    handleMenuClick = ({ key }) => {
        const { rightMenuClick } = this.props;
        rightMenuClick && rightMenuClick(key);
    }
    renderMenus = (rightMenus: any[]) => {
        const { prefixCls } = this.props;
        return (
            <div className={`${prefixCls}-drop-wrap`}>
                <div className={`${prefixCls}-drop-icon-bg`}></div>
                <Menu ecId={`${this && this.props && this.props.ecId || ''}_Menu@x5gccu`}
                    prefixCls="mode-dropdown-menu"
                    className={`${prefixCls}-drop-menu`}
                    onClick={this.handleMenuClick}
                >
                    {
                        rightMenus.map((d, i) => {
                            return <Menu.Item ecId={`${this && this.props && this.props.ecId || ''}_Menu.Item@j2yx7p@${i}`} key={d.key || i} disabled={d.disabled}>
                                <span className={`${prefixCls}-drop-icon`}>{d.icon}</span>
                                {d.content}
                            </Menu.Item>
                        })}
                </Menu>
            </div>
        )
    }
    render() {
        const {
            prefixCls = "coms-mode-menu-wrap",
            rightMenuClick,
            rightMenus = [],
            isDialog = false,
            children,
            quickSize = 5,
            hideRightmenu = false,
            needFixedToTop,
        } = this.props;
        if(hideRightmenu){
            return  <React.Fragment ecId={`${this && this.props && this.props.ecId || ''}_React.Fragment@mpdtf8`} >{children} </React.Fragment>;
        }

        if (isDialog) {
            const quickMenus = rightMenus.slice(0, quickSize);
            return (<div className={prefixCls} ref="_container">
                <WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@fsfk9g`}
                    datas={rightMenus}
                    onClick={rightMenuClick}
                    collectParams={{
                        "favname": "",
                        "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                        "favouritetype": 5,
                        "importantlevel": 1
                    }}
                >
                    {children}
                </WeaRightMenu>
                <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@7v51jz`} className={`${prefixCls}-row`}>
                    <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@yxvfm9`} span={24} >
                        {quickMenus && quickMenus.map((btn,i) => (
                            <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@hm3ber@${i}`} type="primary" onClick={this.handleButtonClick.bind(this, btn.key)}><span className={`${prefixCls}-btn-icon`}>{btn.icon}</span>{btn.content}</Button>
                        ))}
                        <Dropdown ecId={`${this && this.props && this.props.ecId || ''}_Dropdown@s25pmo`} getPopupContainer={() => this.refs._container} overlay={this.renderMenus(rightMenus)} placement="topRight" trigger="click">
                            <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@f2eaef`}>更多>></Button>
                        </Dropdown>
                    </Col>
                </Row>
            </div>
            )
        } else {
            return (
                <WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@aej31g`}
                    datas={rightMenus}
                    onClick={rightMenuClick}
                    collectParams={{
                        "favname": "",
                        "link": '/' + window.location.toString().split('/').slice(3).join('/'),
                        "favouritetype": 5,
                        "importantlevel": 1
                    }}
                    handleVisible={isshow => {
                        if (isshow && needFixedToTop) {
                            $('.coms-mode-viewResource .list-container .wea-right-menu-wrap .wea-right-menu').eq(0).addClass('viewResource-right-menu-toTop');
                        }
                    }}
                >
                    {children}
                </WeaRightMenu>
            )
        }
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/right-menu-wrap/index.tsx